import React, { Fragment } from 'react';
import {
  eActionsGA,
  eCategoriesGA,
  eChannels,
  eInternalEvents,
  ePublishers,
  eTopics
} from '../../../utils/enums';
import {
  extendSportClientSession,
  kickUser
} from '../../../redux/user/user-actions';

import GTMLayer from '../../../facades/gtm-layer-facade';
import Global from '../../../global';
import HtmlHelper from '../../../utils/html-helper';
import InternalPubSub from '../../../services/internal-pub-sub/index';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import customerSettings from '../../../services/kambi-client-sdk/customer-settings';
import { getKambiClientSDK } from '../../../config/kambi/api-config/kambi-config';
import { kambiClientRendered } from '../../../redux/app-ui/app-ui-actions';
import { publishTopicOnChannel } from '../../../services/external-pub-sub/pub-sub-utils';

const createKambiBootstrapNode = (offering, useProdApis) => {
  const timestamp = new Date().setHours(0, 0, 0, 0);

  const kambiBootstrap = document.createElement('script');
  kambiBootstrap.async = true;

  kambiBootstrap.src = `${getKambiClientSDK(
    useProdApis
  )}/${offering}/kambi-bootstrap.js?cb=${timestamp}`;

  kambiBootstrap.setAttribute('data-ot-ignore', '');

  return kambiBootstrap;
};

class KambiClient extends React.Component {
  kambiKeepAliveCallback = null;
  kambiBootsrap = null;
  kambiCallbacks = {
    heartBeatCallback: () => {
      const { userContext, dispatch } = this.props;
      Global.logger.warn(
        `[AUTH] heartbeat received from Kambi - sportClient user is ${
          userContext.isLoggedIn ? '' : 'NOT'
        } logged in`
      );

      if (userContext.isLoggedIn) {
        const channel = eChannels.session;
        const topic = eTopics.session.heartBeat;
        const method = 'heartBeatCallback()',
          data = null,
          headers = { publisher: ePublishers.sportclient };
        publishTopicOnChannel(topic, channel, method, data, headers);
        dispatch(extendSportClientSession(userContext));
      }
    },
    keepAliveCallback: kambiKeepAliveCallback => {
      this.kambiKeepAliveCallback = kambiKeepAliveCallback;
    },
    kickUserCallback: () => {
      const { dispatch, userContext } = this.props;
      Global.logger.warn(
        `[AUTH] kickUser received from Kambi - sportClient user is ${
          userContext.isLoggedIn ? '' : 'NOT'
        } logged in`
      );

      if (!userContext.isLoggedIn) {
        Global.logger.warn('No need for kick/inactivityTimeout');
        return;
      }

      const channel = eChannels.session;
      const topic = eTopics.session.inactivityTimeout;
      const method = 'kickUserCallback()',
        data = null,
        headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);

      dispatch(kickUser());
    },
    notificationsCallback: event => {
      const { dispatch, userContext } = this.props;

      Global.logger.log(`NotificationsCallback: ${event.name}`, event);

      // eslint-disable-next-line no-undef
      switch (event.name) {
        case 'pageRendered':
          setTimeout(() => dispatch(kambiClientRendered()), 500);

          // publishTopicOnChannel('SystemActivity_PageRendered', 'vendor', 'notificationsCallback()- pageRendered');
          break;
        case 'depositRequested': {
          const channel = eChannels.payments;
          const topic = eTopics.payments.CTA_Cashier_Open;
          const method = 'notificationsCallback()- depositRequested',
            data = {
              TabId: 16,
              PromoCode: 'SUNFUN',
              Element: 'UD',
              Area: 'Sport Betslip',
              Source: 'Kambi Sport Client'
            },
            headers = { publisher: 'not-defined' };

          GTMLayer.sendEventToGA(
            eCategoriesGA.Betslip,
            eActionsGA.openDeposit,
            'Deposit'
          );
          publishTopicOnChannel(topic, channel, method, data, headers);
          break;
        }
        case 'placingBetSucceeded': {
          const channel = eChannels.wallet;
          const topic = eTopics.wallet.PlayerAction_BetSucceeded;
          const method = 'notificationsCallback()- placingBetSucceeded',
            data = null,
            headers = { publisher: ePublishers.sportclient };
          publishTopicOnChannel(topic, channel, method, data, headers);
          break;
        }
        case 'placingBetFailed': {
          const channel = eChannels.player;
          const topic = eTopics.player.CTA_Bet_Failed;
          const method = 'notificationsCallback()- placingBetFailed',
            data = null,
            headers = { publisher: ePublishers.sportclient };
          publishTopicOnChannel(topic, channel, method, data, headers);
          break;
        }
        case 'loginRequestDone': {
          // if login successful
          if (event.data) {
            Global.logger.warn('[AUTH] login successful');
            const channel = eChannels.identity;
            const topic = eTopics.identity.userAuthenticationSucceeded;
            const method = 'notificationsCallback()- loginRequestDone';
            const data = null;
            const headers = { publisher: ePublishers.sportclient };
            publishTopicOnChannel(topic, channel, method, data, headers);
          }
          break;
        }
        case 'loginRequested': {
          const { rllogin } = window;
          rllogin && rllogin.show();
          break;
        }

        case 'punterLoginFailed': {
          // handle login request failed
          Global.logger.warn('[AUTH] login failed');
          const channel = eChannels.identity;
          const topic = eTopics.identity.userAuthenticationFailed;
          const method = 'notificationsCallback()- punterLoginFailed';
          // TODO Error code - see error codes list
          // TODO Error description - Descriptive string associated with a specific error.
          const data = {
            errorDescription: event.data.reason,
            errorCode: event.name
          };
          const headers = { publisher: ePublishers.sportclient };
          publishTopicOnChannel(topic, channel, method, data, headers);
          break;
        }
        case 'tracked': {
          break;
        }
        case 'sessionTimedOut': {
          Global.logger.warn(
            `[AUTH] sessionTimedOut received from Kambi - sportClient user is ${
              userContext.isLoggedIn ? '' : 'NOT'
            } logged in`
          );

          if (!userContext.isLoggedIn) {
            Global.logger.warn('No need for inactivityTimeout');
            return;
          }

          const channel = eChannels.session;
          const topic = eTopics.session.inactivityTimeout;
          const method = 'notificationsCallback()- sessionTimedOut',
            data = null,
            headers = { publisher: ePublishers.sportclient };
          publishTopicOnChannel(topic, channel, method, data, headers);
          dispatch(kickUser());
          break;
        }

        default:
          Global.logger.debug('Missed notification => ', event.name);
      }
    },
    showEventStatisticsCallback: eventId => {
      const { langISO2 } = this.props.userContext;
      let { betradarUrl } = this.props.kambiConfigData.settingsJson;
      betradarUrl = `${betradarUrl}/${langISO2}/match/m${eventId}`;
      Global.logger.info(`Statistics link (betradarUrl) is ${betradarUrl}`);
      window.open(
        betradarUrl,
        '_blank',
        'resizable=yes, scrollbars=yes, titlebar=yes, width=1020, height=900, top=10, left=10'
      );
    }
  };

  componentDidMount() {
    const { useProdApis } = this.props.appConfig;

    if (process.env.BROWSER) {
      InternalPubSub.subscribeToEvent(
        eInternalEvents.KeepAliveSportProvider,
        () => {
          Global.logger.warn(
            '[AUTH] extending session left to right kambiKeepAliveCallback()'
          );
          this.kambiKeepAliveCallback();
        }
      );

      //set _kc and customerSettings on window
      const {
        _kc,
        settingsJson,
        offering /*widgetJson*/
      } = this.props.kambiConfigData;
      window.customerSettings = customerSettings(
        settingsJson,
        this.kambiCallbacks,
        this.props.userContext.brand
      );
      window._kc = _kc;

      this.kambiBootsrap = createKambiBootstrapNode(offering, useProdApis);
      //set widgetSettings on window
      /*const widgetsScript = document.createElement("script");
      widgetsScript.innerHTML = widgetJson;*/

      // load kambi client script

      HtmlHelper.appendScriptsToNode('kambiScripts', [
        /*widgetsScript,*/ this.kambiBootsrap
      ]);
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Fragment>
        <div id="kambiWrapper">
          <div id="KambiBC"></div>
        </div>
        <div id="kambiScripts"></div>
      </Fragment>
    );
  }
}

KambiClient.propTypes = {
  kambiConfigData: PropTypes.object,
  userContext: PropTypes.object,
  appConfig: PropTypes.object,
  dispatch: PropTypes.func
};

function mapStateToProps(state) {
  const { userContext, appConfig } = state;
  return { userContext, appConfig };
}

export default connect(mapStateToProps)(KambiClient);
